import { render, staticRenderFns } from "./age.vue?vue&type=template&id=6e3da329&scoped=true"
import script from "./age.vue?vue&type=script&lang=js"
export * from "./age.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3da329",
  null
  
)

export default component.exports